import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Grain } from "@/components/Grain";
import { Hero } from "@/sections/scuba/Hero";
import { About } from "@/sections/scuba/About";
import { Services } from "@/sections/scuba/Services";
import { Gallery } from "@/sections/scuba/Gallery";
import { Contact } from "@/sections/scuba/Contact";

export default function Scuba() {
  const { t } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ocean-deep min-h-screen" data-testid="scuba-page">
      <Grain />
      <Navbar
        theme="ocean"
        links={[
          { label: t.scuba.nav.about, href: "#about" },
          { label: t.scuba.nav.services, href: "#services" },
          { label: t.scuba.nav.gallery, href: "#gallery" },
          { label: t.scuba.nav.contact, href: "#contact" },
        ]}
        ctaLabel={t.scuba.nav.cta}
        ctaHref="#contact"
        logoSuffix="SCUBA"
        logoTo="/scuba"
        backLink={{ to: "/", label: t.scuba.nav.back }}
      />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Contact />
      <Footer
        theme="ocean"
        tagline={t.scuba.footer.tagline}
        rights={t.scuba.footer.rights}
        backLink={{ to: "/", label: t.scuba.nav.back }}
      />
    </div>
  );
}
